import * as ambassadorWixIntakeFormsV1IntakeForm from './intake-forms-v1-intake-form-intake-forms.http.js';
import * as ambassadorWixIntakeFormsV1IntakeFormTypes from './intake-forms-v1-intake-form-intake-forms.types.js';
import * as ambassadorWixIntakeFormsV1IntakeFormUniversalTypes from './intake-forms-v1-intake-form-intake-forms.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryIntakeForms(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.QueryIntakeFormsRequest,
  ambassadorWixIntakeFormsV1IntakeFormTypes.QueryIntakeFormsRequest,
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.QueryIntakeFormsResponse,
  ambassadorWixIntakeFormsV1IntakeFormTypes.QueryIntakeFormsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIntakeFormsV1IntakeForm.queryIntakeForms(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/intake-forms/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateIntakeFormExpirationPeriod(): __PublicMethodMetaInfo<
  'PATCH',
  { intakeFormId: string },
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.UpdateIntakeFormExpirationPeriodRequest,
  ambassadorWixIntakeFormsV1IntakeFormTypes.UpdateIntakeFormExpirationPeriodRequest,
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.UpdateIntakeFormExpirationPeriodResponse,
  ambassadorWixIntakeFormsV1IntakeFormTypes.UpdateIntakeFormExpirationPeriodResponse
> {
  const payload = { intakeFormId: ':intakeFormId' } as any;

  const getRequestOptions =
    ambassadorWixIntakeFormsV1IntakeForm.updateIntakeFormExpirationPeriod(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/intake-forms/{intakeFormId}',
    pathParams: { intakeFormId: 'intakeFormId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCustomerSubmissionLink(): __PublicMethodMetaInfo<
  'GET',
  { intakeFormId: string },
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.CreateCustomerSubmissionLinkRequest,
  ambassadorWixIntakeFormsV1IntakeFormTypes.CreateCustomerSubmissionLinkRequest,
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.CreateCustomerSubmissionLinkResponse,
  ambassadorWixIntakeFormsV1IntakeFormTypes.CreateCustomerSubmissionLinkResponse
> {
  const payload = { intakeFormId: ':intakeFormId' } as any;

  const getRequestOptions =
    ambassadorWixIntakeFormsV1IntakeForm.createCustomerSubmissionLink(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/intake-forms/{intakeFormId}/link',
    pathParams: { intakeFormId: 'intakeFormId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteIntakeForm(): __PublicMethodMetaInfo<
  'DELETE',
  { intakeFormId: string },
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.DeleteIntakeFormRequest,
  ambassadorWixIntakeFormsV1IntakeFormTypes.DeleteIntakeFormRequest,
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.DeleteIntakeFormResponse,
  ambassadorWixIntakeFormsV1IntakeFormTypes.DeleteIntakeFormResponse
> {
  const payload = { intakeFormId: ':intakeFormId' } as any;

  const getRequestOptions =
    ambassadorWixIntakeFormsV1IntakeForm.deleteIntakeForm(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/intake-forms/{intakeFormId}',
    pathParams: { intakeFormId: 'intakeFormId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function archiveIntakeForm(): __PublicMethodMetaInfo<
  'POST',
  { intakeFormId: string },
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.ArchiveIntakeFormRequest,
  ambassadorWixIntakeFormsV1IntakeFormTypes.ArchiveIntakeFormRequest,
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.ArchiveIntakeFormResponse,
  ambassadorWixIntakeFormsV1IntakeFormTypes.ArchiveIntakeFormResponse
> {
  const payload = { intakeFormId: ':intakeFormId' } as any;

  const getRequestOptions =
    ambassadorWixIntakeFormsV1IntakeForm.archiveIntakeForm(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/intake-forms/{intakeFormId}/archive',
    pathParams: { intakeFormId: 'intakeFormId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unarchiveIntakeForm(): __PublicMethodMetaInfo<
  'POST',
  { intakeFormId: string },
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.UnarchiveIntakeFormRequest,
  ambassadorWixIntakeFormsV1IntakeFormTypes.UnarchiveIntakeFormRequest,
  ambassadorWixIntakeFormsV1IntakeFormUniversalTypes.UnarchiveIntakeFormResponse,
  ambassadorWixIntakeFormsV1IntakeFormTypes.UnarchiveIntakeFormResponse
> {
  const payload = { intakeFormId: ':intakeFormId' } as any;

  const getRequestOptions =
    ambassadorWixIntakeFormsV1IntakeForm.unarchiveIntakeForm(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/intake-forms/{intakeFormId}/unarchive',
    pathParams: { intakeFormId: 'intakeFormId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  IntakeForm as IntakeFormOriginal,
  PendingTriggerField as PendingTriggerFieldOriginal,
  ApprovalMode as ApprovalModeOriginal,
  ApprovalModeWithLiterals as ApprovalModeWithLiteralsOriginal,
  QueryIntakeFormsRequest as QueryIntakeFormsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryIntakeFormsResponse as QueryIntakeFormsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateIntakeFormExpirationPeriodRequest as UpdateIntakeFormExpirationPeriodRequestOriginal,
  UpdateIntakeFormExpirationPeriodResponse as UpdateIntakeFormExpirationPeriodResponseOriginal,
  UpdateIntakeFormSettingsRequest as UpdateIntakeFormSettingsRequestOriginal,
  UpdateIntakeFormSettingsResponse as UpdateIntakeFormSettingsResponseOriginal,
  CreateCustomerSubmissionLinkRequest as CreateCustomerSubmissionLinkRequestOriginal,
  CreateCustomerSubmissionLinkResponse as CreateCustomerSubmissionLinkResponseOriginal,
  DeleteIntakeFormRequest as DeleteIntakeFormRequestOriginal,
  DeleteIntakeFormResponse as DeleteIntakeFormResponseOriginal,
  ArchiveIntakeFormRequest as ArchiveIntakeFormRequestOriginal,
  ArchiveIntakeFormResponse as ArchiveIntakeFormResponseOriginal,
  UnarchiveIntakeFormRequest as UnarchiveIntakeFormRequestOriginal,
  UnarchiveIntakeFormResponse as UnarchiveIntakeFormResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  DecryptContactDetailsFromTokenRequest as DecryptContactDetailsFromTokenRequestOriginal,
  DecryptContactDetailsFromTokenResponse as DecryptContactDetailsFromTokenResponseOriginal,
  ContactDetails as ContactDetailsOriginal,
  CreateCustomerSubmissionLinkApplicationErrors as CreateCustomerSubmissionLinkApplicationErrorsOriginal,
} from './intake-forms-v1-intake-form-intake-forms.types.js';
